export const conversationFeatureKey = 'conversation';
